import { type FC } from "react";

import { BUSINESS_MANAGER_URL } from "../../shared/constants";

import { EmptyFeaturePage } from "./EmptyFeaturePage";
import { CardContent } from "./EmptyFeaturePage.styles";
import { BusinessManagerLinkText, DefaultMembershipMessage, LensInsightsNotAvailalble } from "./messages.generated";

export const InsightsNotPermittedPage: FC = () => (
    <EmptyFeaturePage title={<LensInsightsNotAvailalble />}>
        <CardContent>
            <CardContent>
                <DefaultMembershipMessage
                    link={
                        <a href={BUSINESS_MANAGER_URL} target="_blank" rel="noreferrer">
                            <BusinessManagerLinkText />
                        </a>
                    }
                />
            </CardContent>
        </CardContent>
    </EmptyFeaturePage>
);
